<template>
  <div class="agents-table-wrapper">
    <!-- Header -->
    <div class="agents-header">
      <h3 class="agents-title">
        {{ "KPI" }}
        <icon v-if="loading" name="spinner" spin class="loading-icon"></icon>
      </h3>
      <div class="header-controls">
        <ulu-date-picker
          range
          v-model="range"
          lang="en"
          format="DD.MM.YYYY"
          :placeholder="$t('globals.all')"
          class="modern-date-picker"
        />
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="modern-table">
        <thead>
          <tr>
            <th
              v-for="field in fields"
              :key="field.key"
              :class="{ sortable: field.sortable, 'sort-active': sortBy === field.key }"
              @click="field.sortable ? sort(field.key) : null"
            >
              {{ field.label || field.key }}
              <span v-if="field.sortable && sortBy === field.key" class="sort-icon">
                {{ sortDesc ? '▼' : '▲' }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td :colspan="fields.length" class="loading-state">
              <icon name="spinner" spin class="spinner"></icon>
              <p>Loading data...</p>
            </td>
          </tr>
          <tr v-else-if="stats.length === 0">
            <td :colspan="fields.length" class="empty-state">
              No data available
            </td>
          </tr>
          <tr v-else v-for="(item, index) in sortedStats" :key="index">
            <td>{{ item.agent }}</td>
            <td>{{ item.no_inquiries }}</td>
            <td>{{ item.no_orders }}</td>
            <td>{{ item.no_devices }}</td>
            <td>{{ item.vel10_sold }}</td>
            <td>{{ item.velpro_sold }}</td>
            <td>{{ item.at4m_sold }}</td>
            <td>{{ item.twdashcam_sold }}</td>
            <td>{{ item.cmm1_sold }}</td>
            <td>{{ item.cmm3_sold }}</td>
            <td>{{ item.cmm4_sold }}</td>
            <td>{{ item.avg_connectivity != null ? currencyFormat(item.avg_connectivity) : '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { mapActions, mapGetters } from "vuex";
import { currencyFormat } from "@/helpers/price";

import "vue-awesome/icons/spinner";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue"),
    "ulu-date-picker": DatePicker
  },
  data() {
    return {
      range: [null, null],
      formatedRange: [null, null],
      loading: false,
      stats: [],
      sortBy: null,
      sortDesc: false,
      fields: [
        {
          key: "agent",
          label: this.$t("globals.agent"),
          sortable: true
        },
        {
          key: "no_inquiries",
          label: this.$t("globals.inquiries"),
          sortable: true
        },
        {
          key: "no_orders",
          label: this.$t("globals.orders"),
          sortable: true
        },
        {
          key: "no_devices",
          label: this.$t("globals.all_devices"),
          sortable: true
        },
        {
          key: "vel10_sold",
          sortable: true
        },
        {
          key: "velpro_sold",
          sortable: true
        },
       
        {
          key: "at4m_sold",
          sortable: true
        },
        
        {
          key: "twdashcam_sold",
          sortable: true
        },
        {
          key: "cmm1_sold",
          sortable: true
        },
        {
          key: "cmm3_sold",
          sortable: true
        },
        {
          key: "cmm4_sold",
          sortable: true
        },
        
        
        
       
        {
          key: "avg_connectivity",
          sortable: true
        }
      ]
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    currencyFormat,
    sort(key) {
      if (this.sortBy === key) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = key;
        this.sortDesc = false;
      }
    },
    fetchData() {
      const data = {
        query: `
          query {
            AgentsKpisRange (
              ${ this.formatedRange[0]
                ? 'from: "' +this.formatedRange[0] + '", to: "' + this.formatedRange[1] + '"'
                : ''
              }
            )
          }
        `
      };

      this.loading = true;
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.stats = [];
          JSON.parse(res.AgentsKpisRange).forEach(e => {
            this.stats.push(JSON.parse(e))
          });
        }
      }).finally(()=>{
        this.loading = false;
      });
    }
  },
  computed: {
    ...mapGetters(["getThisYearRange","getUserSystem"]),
    sortedStats() {
      if (!this.sortBy) {
        return this.stats;
      }

      const sorted = [...this.stats].sort((a, b) => {
        let aVal = a[this.sortBy];
        let bVal = b[this.sortBy];

        // Handle null/undefined values
        if (aVal == null) aVal = '';
        if (bVal == null) bVal = '';

        // Handle numeric values
        if (typeof aVal === 'number' && typeof bVal === 'number') {
          return this.sortDesc ? bVal - aVal : aVal - bVal;
        }

        // Handle string values
        const aStr = String(aVal).toLowerCase();
        const bStr = String(bVal).toLowerCase();

        if (this.sortDesc) {
          return bStr.localeCompare(aStr);
        } else {
          return aStr.localeCompare(bStr);
        }
      });

      return sorted;
    }
  },
  watch: {
    getUserSystem: function() {
      this.fetchData();
    },
    range: function(newRange) {
      if (newRange[0] !== null && newRange[1] !== null) {
        let from = new Date(newRange[0]);
        let to = new Date(newRange[1]);

        from.setHours(from.getHours() + 1);
        to.setHours(to.getHours() + 25);

        this.formatedRange = [
          `${from.getFullYear()}-${from.getMonth()+1}-${from.getDate()}`,
          `${to.getFullYear()}-${to.getMonth()+1}-${to.getDate()}`
        ];

        this.fetchData()
      } else {
        this.formatedRange = [null, null];
        this.fetchData()
      }
    }
  },
  mounted() {
    this.range = this.getThisYearRange
    this.fetchData();
  }
};
</script>

<style scoped>
.agents-table-wrapper {
  padding: 24px;
  background-color: #f7f7f7;
}

.agents-header {
  background: white;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.agents-title {
  font-size: 20px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.loading-icon {
  font-size: 18px;
  color: #5469d4;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.modern-date-picker {
  max-width: 300px;
}

/* Table Wrapper */
.table-wrapper {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

/* Modern Table */
.modern-table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  table-layout: auto;
}

.modern-table thead {
  background-color: #f8f9fa;
}

.modern-table th {
  padding: 0.75rem 0.5rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  border-bottom: 1px solid #e0e0e0;
  white-space: normal;
  line-height: 1.3;
  vertical-align: top;
  min-width: 80px;
}

.modern-table th:first-child {
  padding-left: calc(0.5rem + 5px);
}

.modern-table th:last-child {
  padding-right: calc(0.5rem + 5px);
}

.modern-table th.sortable {
  cursor: pointer;
  user-select: none;
  position: relative;
}

.modern-table th.sortable:hover {
  background-color: #e9ecef;
}

.modern-table th.sort-active {
  background-color: #e9ecef;
  color: #5469d4;
  font-weight: 700;
}

.sort-icon {
  margin-left: 4px;
  font-size: 0.75em;
  color: #5469d4;
}

.modern-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.15s;
}

.modern-table tbody tr:hover {
  background-color: #f8f9fa;
}

.modern-table td {
  padding: 0.75rem 0.5rem;
  font-size: 0.875rem;
  color: #495057;
  line-height: 1.4;
  vertical-align: middle;
}

.modern-table td:first-child {
  padding-left: calc(0.5rem + 5px);
  font-weight: 600;
  color: #2d3748;
}

.modern-table td:last-child {
  padding-right: calc(0.5rem + 5px);
}

.loading-state,
.empty-state {
  padding: 3rem;
  text-align: center;
  color: #6c757d;
  font-size: 0.9375rem;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.loading-state .spinner {
  font-size: 32px;
  color: #5469d4;
}

.loading-state p {
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .agents-table-wrapper {
    padding: 16px;
  }

  .agents-header {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
  }

  .header-controls {
    width: 100%;
  }

  .modern-date-picker {
    width: 100%;
    max-width: 100%;
  }

  .modern-table th,
  .modern-table td {
    padding: 0.5rem 0.3rem;
    font-size: 0.75rem;
  }
}
</style>
